import React from 'react'
import styled from 'styled-components'

const Occupant = ({employee}) => {
  const {emId, name, emTitle, dpName} = employee
  return (
    <Row key={emId}>
      <Name>
        {name || emId}
        <Title>
          {emTitle}
          <StyledDot>&#183;</StyledDot>
          {dpName}
        </Title>
      </Name>
    </Row>
  )
}

export default Occupant

const Row = styled.div`
  display: flex;
  margin: 10px 0 20px 0;
  width: 100%;
  box-sizing: border-box;
  align-items: center;
  background: #f3f5fb;
  border-radius: 6px;
`

const StyledDot = styled.span`
  padding: 0 10px 0 10px;
`

const Name = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #000000;
  flex: 1;
  width: 100%;
  box-sizing: border-box;
  padding-left: 10px;
  letter-spacing: -0.3px;
`

const Title = styled.div`
  font-size: 13px;
  font-weight: normal;
  color: #a4a9b7;
`
